import type { SelectOption, SelectOptionValue } from "./select.js";

type Props = {
  selectedOptions: SelectOption<SelectOptionValue>[];
  multiple?: boolean;
  placeholder?: string;
  darkSelectedText?: boolean;
};

export const SelectInputText = ({
  selectedOptions,
  placeholder,
  multiple,
  darkSelectedText,
}: Props) => {
  if (selectedOptions.length === 0) {
    return <span className="text-gray-400">{placeholder}</span>;
  }

  if (multiple) {
    if (selectedOptions.length > 1) {
      return (
        <span className="text-gxe-primary font-semibold">{selectedOptions.length} selected</span>
      );
    }
    return darkSelectedText ? (
      <span className="text-black">{selectedOptions.map((opt) => opt.label).join(", ")}</span>
    ) : (
      selectedOptions.map((opt) => opt.label).join(", ")
    );
  }

  return darkSelectedText ? (
    <span className="text-black">{selectedOptions[0]?.label}</span>
  ) : (
    selectedOptions[0]?.label
  );
};
